// app/javascript/form/nested_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["target", "template"]

  static values = {
    wrapperSelector: {
      type: String,
      default: ".nested-form-wrapper",
    },
    insertLocation: {
      type: String,
      default: "beforebegin"
    },
    destroySelector: {
      type: String,
      default: "input[name*='_destroy']"
    },
  }

  add(event) {
    event.preventDefault()
    this.addElement()
  }

  addElement() {
    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime().toString())
    this.targetTarget.insertAdjacentHTML(this.insertLocationValue, content)

    const customEvent = new CustomEvent("form--nested:add", { bubbles: true })
    this.element.dispatchEvent(customEvent)
  }

  remove(event) {
    event.preventDefault()

    const wrapper = event.target.closest(this.wrapperSelectorValue)
    this.removeElement(wrapper)
  }

  removeElement(wrapper) {
    if (wrapper.dataset.newRecord === "true") {
      wrapper.remove()
    } else {
      wrapper.style.display = "none"

      const input = wrapper.querySelector(this.destroySelectorValue)
      input.value = "1"
    }

    const customEvent = new CustomEvent("form--nested:remove", { bubbles: true })
    this.element.dispatchEvent(customEvent)
  }
}
